import React from "react";
import { Box, Stack } from "digiwash-components";

interface ToggleSwitchType {
  selected: boolean;
  enableBackgroundColor?: string;
  disableBackgroundColor?: string;
}

function ToggleSwitch(props: ToggleSwitchType) {
  let enableBg = props.enableBackgroundColor || "primary.main";
  let disableBg = props.disableBackgroundColor || "gray.light";

  return (
    <Stack
      style={{
        width: 40,
        height: 24,
        position: "relative",
        padding: 1,
        borderRadius: 16,
      }}
      bg={props.selected ? enableBg : disableBg}
    >
      <Box
        bg="common.white"
        br="circle"
        style={{
          width: 22,
          height: 22,
          position: "absolute",
          right: props.selected ? null : 1,
          left: props.selected ? 1 : null,
        }}
      ></Box>
    </Stack>
  );
}

export default ToggleSwitch;
